<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .skeleton {
    @include mixins.skeleton(
      (
        background-color: colors.get(interfaceTransparentBlack_4),
        border-radius: 8px,
      )
    );
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    overflow: hidden;
  }

  .medium {
    height: utils.in_rem(40px);
    width: utils.in_rem(40px);
  }

  .large {
    height: utils.in_rem(66px);
    width: utils.in_rem(66px);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .missing {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;

    border-radius: 8px;
    background-color: colors.get(interfaceSwGrey_10);
    color: colors.get(textGrey);
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";

  export let size = "medium";
  export let logo;
  export let skeleton;

  let logoError = false; // when using this component, need to wrap in {#key logo} to reset logoError when the logo changes
</script>

<div class="container {size}" class:skeleton>
  {#if logo && !logoError}
    <img
      src={logo}
      alt="logo"
      on:error={() => {
        logoError = true;
      }}
    />
  {:else if !skeleton}
    <div class="missing">
      <Icon class="far fa-image" {size} />
    </div>
  {/if}
</div>
